import React, { useEffect, useContext } from 'react';
import { Questionnaire } from '@dmm/lib-react-ui-components';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { syncTranslationElements } from '../../../tppServices/translations/intlManager';
import { save } from '../../../requests/questionnaireRequest';
import { PortalConfigContext } from '../../../config/portal';
import { definedValue, isNotEmptyString } from '../../../utils';

const BDPQuestionnaire = (props) => {
  const intl = useIntl();
  const { messages, t } = syncTranslationElements(intl);
  const {
    breakpoint,
    handleCloseClick,
    handleDoneClick,
    handleSkipClick,
    sendModalInteraction,
    userQuestionnaire
  } = props;

  const context = useContext(PortalConfigContext);

  const questions = definedValue(userQuestionnaire?.questions?.questionnaires?.[0]?.question, []);

  useEffect(() => {
    const modalWrapper = document.querySelector('.stepper-modal-wrapper');

    if (modalWrapper) {
      modalWrapper.classList.add('questionnaire-shown');

      const handleQuestionnaireInteraction = () => {
        sendModalInteraction();
        modalWrapper.removeEventListener('click', handleQuestionnaireInteraction);
      };

      modalWrapper.addEventListener('click', handleQuestionnaireInteraction);

      return () => {
        modalWrapper.classList.remove('questionnaire-shown');
        modalWrapper.removeEventListener('click', handleQuestionnaireInteraction);
      };
    }
  }, []);

  const handleFormSubmit = async() => {
    const form = document.querySelector('[class*="questionnaire-form"]');
    const formData = new FormData(form);

    // Isolate to a new function in PRIME-2378
    const answers = {
      category: 'question',
      username: userQuestionnaire.username,
      responses: []
    };

    const formEntries = Array.from(formData.entries());
    formEntries.forEach(([, value], index) => {
      const currentQuestion = questions[index];
      isNotEmptyString(value) && answers.responses.push({ key: currentQuestion.key, value });
    });

    await save(answers, context);
    handleDoneClick();
  };

  return (
    <div
      data-testid="questionnaire"
      className={`questionnaire ${breakpoint === 'mobile' ? 'mobile-view' : ''}`}
    >
      <Questionnaire
        headerText={t(messages.questionnaire.headerText)}
        introText={t(messages.questionnaire.introText)}
        doneButtonText={t(messages.questionnaire.doneButtonText)}
        skipButtonText={t(messages.questionnaire.skipButtonText)}
        handleSkipClick={handleSkipClick}
        handleDoneClick={handleFormSubmit}
        onClose={handleCloseClick}
        questions={questions}
        doneButtonAttributes={{ 'data-testing': 'questions-submitted' }}
        skipButtonAttributes={{ 'data-testing': 'questions-skipped' }}
      />
    </div>
  );
};

BDPQuestionnaire.propTypes = {
  breakpoint: PropTypes.string,
  handleCloseClick: PropTypes.func,
  handleDoneClick: PropTypes.func,
  handleSkipClick: PropTypes.func,
  sendModalInteraction: PropTypes.func,
  userQuestionnaire: PropTypes.object,
};

export default BDPQuestionnaire;
